<mat-card class="tic-card">
  <mat-card-header>
    <mat-card-title class="vmt-card-title-row">
      <mat-icon class="vmt-card-title-icon">description</mat-icon>
      {{ resolvedTitle }}
    </mat-card-title>
    <mat-card-subtitle *ngIf="data.cardSubtitle">{{ data.cardSubtitle }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="vmt-info-content">

    <!-- Loading progress bar during provisioning / initial meta load -->
    <div *ngIf="data.isLoading" class="vmt-meta-loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <div class="vmt-info-grid">

      <!-- Template Name — only shown when cardTitle overrides the header title -->
      <div class="vmt-info-item vmt-info-full" *ngIf="showNameRow">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">label</mat-icon>Template Name
        </span>
        <span class="vmt-info-value" [matTooltip]="data.name" matTooltipShowDelay="600">
          {{ data.name }}
        </span>
      </div>

      <!-- Cloud Provider -->
      <div class="vmt-info-item" *ngIf="data.provider">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">cloud</mat-icon>Provider
        </span>
        <span class="vmt-info-value">{{ data.provider }}</span>
      </div>

      <!-- Region -->
      <div class="vmt-info-item" *ngIf="data.region">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">location_on</mat-icon>Region
        </span>
        <span class="vmt-info-value" [matTooltip]="data.region" matTooltipShowDelay="600">
          {{ data.region }}
        </span>
      </div>

      <!-- VM Size (SKU) -->
      <div class="vmt-info-item vmt-info-full" *ngIf="data.vmSize">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">memory</mat-icon>VM Size (SKU)
        </span>
        <span class="vmt-info-value" [matTooltip]="data.vmSize" matTooltipShowDelay="600">
          {{ data.vmSize }}
        </span>
      </div>

      <!-- Storage (optional — present in vm-template-settings) -->
      <div class="vmt-info-item vmt-info-full" *ngIf="data.storage">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">storage</mat-icon>Storage
        </span>
        <span class="vmt-info-value" [matTooltip]="data.storage" matTooltipShowDelay="600">
          {{ data.storage }}
        </span>
      </div>

      <!-- OS -->
      <div class="vmt-info-item vmt-info-full" *ngIf="data.osLabel">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">desktop_windows</mat-icon>OS
        </span>
        <span class="vmt-info-value" [matTooltip]="data.osLabel" matTooltipShowDelay="600">
          {{ data.osLabel }}
        </span>
      </div>

      <!-- Software Stack — compact category-count chips with tooltip listing individual items -->
      <div class="vmt-info-item vmt-info-full" *ngIf="hasSoftware">
        <span class="vmt-info-label">
          <mat-icon class="vmt-meta-icon">apps</mat-icon>Software Stack
        </span>
        <div class="otp-software-summary">
          <span *ngIf="data.sdks.length" class="otp-soft-cat-chip" [matTooltip]="data.sdks.join(' · ')"
            matTooltipShowDelay="200">
            <mat-icon>code</mat-icon>
            {{ data.sdks.length }} SDK{{ data.sdks.length !== 1 ? 's' : '' }}
          </span>
          <span *ngIf="data.databases.length" class="otp-soft-cat-chip" [matTooltip]="data.databases.join(' · ')"
            matTooltipShowDelay="200">
            <mat-icon>storage</mat-icon>
            {{ data.databases.length }} DB{{ data.databases.length !== 1 ? 's' : '' }}
          </span>
          <span *ngIf="data.editors.length" class="otp-soft-cat-chip" [matTooltip]="data.editors.join(' · ')"
            matTooltipShowDelay="200">
            <mat-icon>edit_note</mat-icon>
            {{ data.editors.length }} Editor{{ data.editors.length !== 1 ? 's' : '' }}
          </span>
          <span *ngIf="data.tools.length" class="otp-soft-cat-chip" [matTooltip]="data.tools.join(' · ')"
            matTooltipShowDelay="200">
            <mat-icon>construction</mat-icon>
            {{ data.tools.length }} Tool{{ data.tools.length !== 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      <!-- Installation Status — clickable; hidden when installationSummary is absent or status is draft/creating/destroyed/failed -->
      <div class="vmt-info-item vmt-info-full" *ngIf="showInstallationStatus">
        <span class="vmt-info-label vmt-installation-clickable" (click)="openDrawer()">
          <mat-icon class="vmt-meta-icon" [ngClass]="installIconConfig.cssClass">{{ installIconConfig.icon
            }}</mat-icon>Installation Status (click to view)
        </span>
      </div>

    </div>

    <!-- State chip -->
    <div class="vmt-state-chip-row" *ngIf="data.status">
      <span class="vmt-state-chip" [ngClass]="chipConfig.cssClass">
        <mat-icon class="chip-icon">{{ chipConfig.icon }}</mat-icon>
        {{ chipConfig.label }}
      </span>
    </div>

  </mat-card-content>
</mat-card>